// action types

import ApiService from "@/core/services/api.service";

export default {
  state: {
    stepOneData: [],
    stepTwoData: [],
    stepThreeData: [],
    stepFourData: [],
    jobRedirectData: null,
  },

  getters: {
    stepOneData(state) {
      return state.stepOneData;
    },
    stepTwoData(state) {
      return state.stepTwoData;
    },
    stepThreeData(state) {
      return state.stepThreeData;
    },
    stepFourData(state) {
      return state.stepFourData;
    },
    getJobRedirectData(state) {
      return state.jobRedirectData;
    },
  },

  actions: {
    removeAllData(context) {
      context.commit("removeStepOneData");
      context.commit("removeStepTwoData");
      context.commit("removeStepThreeData");
      context.commit("removeStepFourData");
    },

    createJob(context) {
      return new Promise((resolve, reject) => {
        ApiService.post("api/v2/jobs", {
          data: context.state.stepOneData.data,
          militaryServiceStatusId:
            context.state.stepOneData.militaryServiceStatusId,
          steps: context.state.stepThreeData,
          users: context.state.stepTwoData,
          fields: context.state.stepFourData.public,
          customFields: context.state.stepFourData.custom,
          formId: context.state.stepFourData.formId,
        })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ err }) => {
            reject(err);
          });
      });
    },
  },

  mutations: {
    saveStepOneData(state, item) {
      state.stepOneData = item;
    },
    removeStepOneData(state) {
      state.stepOneData = [];
    },
    saveStepTwoData(state, item) {
      state.stepTwoData = item;
    },
    removeStepTwoData(state) {
      state.stepTwoData = [];
    },
    saveStepThreeData(state, item) {
      state.stepThreeData = item;
    },
    removeStepThreeData(state) {
      state.stepThreeData = [];
    },
    saveStepFourData(state, item) {
      state.stepFourData = item;
    },
    removeStepFourData(state) {
      state.stepFourData = [];
    },
    saveJobRedirectData(state, item) {
      state.jobRedirectData = item;
    },
    removeJobRedirectData(state) {
      state.jobRedirectData = null;
    },
  },
};
